import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { format, parseISO } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';

const EventDetailModal = ({ show, handleClose, event }) => {
    if (!event) {
        return null;
    }

    // Funzione per formattare la data e l'ora
    const formatDateTime = (dateTimeString) => {
        if (!dateTimeString) return 'N/D';
        return format(parseISO(dateTimeString), 'dd/MM/yyyy HH:mm');
    };

    // Funzione per formattare solo la data (per eventi tutto il giorno)
    const formatDate = (dateString) => {
        if (!dateString) return 'N/D';
        return format(parseISO(dateString), 'dd/MM/yyyy');
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>{event.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p><strong>Descrizione:</strong> {event.resource.description || 'N/D'}</p>
                <p><strong>Luogo:</strong> {event.resource.location || 'N/D'}</p>
                {event.allDay ? (
                    <p><strong>Periodo:</strong> Tutto il giorno dal {formatDate(event.resource.start.date)} al {formatDate(event.resource.end.date)}</p>
                ) : (
                    <>
                        <p><strong>Inizio:</strong> {formatDateTime(event.resource.start.dateTime)}</p>
                        <p><strong>Fine:</strong> {formatDateTime(event.resource.end.dateTime)}</p>
                    </>
                )}
                {event.resource.htmlLink && (
                    <Button 
                        variant="outline-info" 
                        href={event.resource.htmlLink} 
                        target="_blank" 
                        className="mt-2"
                    >
                        <FontAwesomeIcon icon={faExternalLinkAlt} /> Apri su Google Calendar
                    </Button>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Chiudi
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EventDetailModal;
